module.exports = __webpack_public_path__ + "img/BBB-Logo.95cb1c52.svg";